import { Permission, usePermission } from '@bonusly/who-am-i';

import { Bonus, BonusPrivacy } from '../../../../../../types/bonus';
import { useContextualizedBonusDetails } from '../../../hooks/use-contextualized-bonus-details';
import { useSayThanks } from '../../../hooks/use-say-thanks';

export const useActions = (bonus: Bonus) => {
	const canAccessAdvice = usePermission(Permission.CanAccessAdvice);

	const displayThanks = useSayThanks(bonus);
	const { canUserAddOn, isUserReceiver, isUserReceiversManager, isGiverHuman, onlyOneReceiver } = useContextualizedBonusDetails(bonus);
	const hasLinkedFeedback = !!bonus.evaluations?.length;
	const isPublic = bonus.privacy === BonusPrivacy.Public;
	const isFeedbackCandidate = bonus.traits?.some((trait) => trait.name === 'feedback_candidate') ?? false;

	// TODO Remove once we confirm the biz logic is correct
	const showFeedbackButton = false;
	const displayFeedback = canAccessAdvice && isGiverHuman && (isUserReceiver || (isUserReceiversManager && onlyOneReceiver)) && isPublic && showFeedbackButton;

	const displayFeedbackPanel = displayFeedback && !hasLinkedFeedback && isPublic && isFeedbackCandidate;

	const displayAddOn = canUserAddOn;

	return {
		displayAddOn,
		displayFeedback,
		displayFeedbackPanel,
		displayThanks,
	};
};
